import React, { PureComponent } from 'react';

class ProgressBar extends PureComponent {
    render() {
        const { categoryID } = this.props;
        const width = parseInt(categoryID) / 11 * 100;

        return (
            <div className="progressbar">
                <p className="progressbar-current" style={{ transform: `translateX(${width-3}%)` }}>
                    {categoryID < 10 ? `0${categoryID}` : categoryID}
                </p>
                <div className="progressbar-bar">
                    <span style={{ width: `${width}%` }} />
                </div>
                <p className="progressbar-total" style={{ transform: `translateX(${width-3}%)` }}>
                    11
                </p>
            </div>
        );
    }
}

export default ProgressBar;



// WEBPACK FOOTER //
// ./src/Question/ProgressBar.js